<span class="status-badge" [ngClass]="'status-badge--' + tone" [class.status-badge--icon-only]="iconOnly">
  <span class="visually-hidden" *ngIf="srLabel">{{ srLabel }}</span>
  <ng-container *ngIf="iconOnly; else textLabel">
    <mat-icon *ngIf="icon; else emptyIcon" aria-hidden="true">{{ icon }}</mat-icon>
    <ng-template #emptyIcon><span aria-hidden="true">-</span></ng-template>
    <span class="visually-hidden">{{ label }}</span>
  </ng-container>
  <ng-template #textLabel>{{ label }}</ng-template>
</span>
